import React from 'react'
import { FormControl, Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import { useTranslation } from 'react-i18next'

export default function PrintSettingsDialog(props) {
  const { open, setOpen, optimizedJobs, printJobs, redirect, setOverridePreferences } = props
  const { t } = useTranslation()

  const handleClose = (value) => {
    setOpen(false)
    if (value === 'current') {
      setOverridePreferences(false)
      printJobs(optimizedJobs)
    }

    if (value === 'override') {
      setOverridePreferences(true)
      redirect()
    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogActions
          sx={{ color: 'white', backgroundColor: 'black' }}
        >
          <FormControl sx={{
              marginTop: '30px',
              marginBottom: '20px'
            }}
          >
            <Button
              onClick={()=>{
                handleClose('current')
              }}
              sx={{ color: 'white', marginLeft: '20px', marginTop: '15px', marginRight: '17px', marginBottom: '10px' }}
              variant='contained'
            >
              {t("Use Default Print Settings")}
            </Button>
            <Button
              onClick={()=>{
                handleClose('override')
              }}
              sx={{ color: 'white', marginLeft: '20px', marginTop: '20px', marginRight: '17px', marginBottom: '10px' }}
              variant='contained'
            >
              {t("Select New Print Settings")}
            </Button>
          </FormControl>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}